import React, { Component } from 'react';
import './App.scss'
import NumberFormat from "react-number-format"

import { observable, computed } from 'mobx'
import { observer } from 'mobx-react'

class App extends Component {
	render() {
		return (
			<div>
				<h1><i className="fa fa-calculator"></i> Simple Tax Calculator (including GST for Australia)</h1>
				<p>This calculator will help you set your own tax rates, before cost and after cost taxation. GST is a common tax of 10% in Australia for Goods and Services. You can see how much you can claim in tax credits.</p>

				<Calculator />

				
				<h2>GST Calculations</h2>
				<p>There are two types of GST, which including. 
					
				</p>
				<ul>
						<li><b>GST Inclusive:</b> The amount of GST Tax is included in the price of the product, and </li>
						<li><b>GST Exclusive:</b> Where the amount of GST is not included, and only added afterwards.</li>
					</ul>
				<h2>How to Calculate the Tax for GST</h2>
				<p>
					If you want to know the formula for calculate your own GST, please see the options below:
				</p>
				<pre>
						Price * Tax = Total (inc Tax) <br />
						eg. $100 * 1.1 = $110 (including tax)
					</pre>
				<p>
				If you want to calculate the tax amount before purchase, the following formula can be used:
				</p>
				<pre>
						Price / Tax = Total (ex Tax) <br />
						eg. $110 / 1.1 = $100 (excluding tax)
					</pre>
			</div>
		);
	}
}

@observer
class Calculator extends Component {

	@observable amount 
	@observable tax = 10

	roundToTwo(num) {    
		return +(Math.round(num + "e+2")  + "e-2");
	}

	@computed get excludingGstAmount() {
		return ( this.excludingTotalAmount * (this.tax / 100) )
	}

	@computed get excludingTotalAmount() {
		if (!this.amount) {
			return 0
		}
		if (!this.tax) {
			return 0
		}
		let tax = (this.tax / 100) + 1
		return ( this.amount / tax )
	}

	@computed get inclusiveGstAmount() {
		return ( this.amount * (this.tax / 100) )
	}

	@computed get inclusiveTotalAmount() {
		if (!this.amount) {
			return 0
		}
		if (!this.tax) {
			return 0
		}
		let tax = ((this.tax / 100) + 1)
		return this.roundToTwo( this.amount * tax )
	}

	render() {
		return (
			<div className="calculator">
				
				<div>

					<div>
						<div>
							<b>Amount:</b>
						</div>
						<div>
							<input type="number" placeholder="Amount... ($100)" value={this.amount} onChange={e=>this.amount = e.target.value} />
						</div>
					</div>

					<div>
						<div>
							<b>Tax:</b>
						</div>
						<input type="number" placeholder="Tax... (10)" value={this.tax}  onChange={e=>this.tax = e.target.value} />
					</div>
				</div>
				
				<table>
					<tbody>
						<tr>
							<th colSpan="2">Adding Tax</th>
						</tr>
						<tr>
							<td>
								Before Tax
							</td>
							<td>
								<NumberFormat value={this.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
						<tr>
							<td>
								Tax Amount
							</td>
							<td>
								<NumberFormat value={this.inclusiveGstAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
						<tr>
							<td>
								Total (including Tax)
							</td>
							<td>
								<NumberFormat value={this.inclusiveTotalAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
						<tr>
							<th colSpan="2">Removing Tax</th>
						</tr>
						<tr>
							<td>
								Total (including Tax)
							</td>
							<td>
								<NumberFormat value={this.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
						<tr>
							<td>
								Tax Amount
							</td>
							<td>
								<NumberFormat value={this.excludingGstAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
						<tr>
							<td>
								Before Tax
							</td>
							<td>
								<NumberFormat value={this.excludingTotalAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}



export default App;


// WEBPACK FOOTER //
// ./src/App.js